export const DialCodes = {
  india: '+91',
};
export const CountryCodes = {
  india: 'IN',
};
